import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { confirmAction, showError, showMessage } from '../../actions/uiActions';
import AccountsApi from '../../api/accounts';
import EditAnalysis from '../EditAnalysis';
import AnalysisTool from '../../utils/AnalysisTools';
import Auth from '../../api/auth';
import AnalysisOutcome from '../AnalysisOutcome';
import AnalysisApi from '../../api/analysis';
import Loading from '../Loading';
import ToggleAnalysis from './../ToggleAnalysis/index';
import Error from '../Error';
import { TextField } from '@mui/material';
class StrategyView extends Component {
  state = {
    busy: false,
    mode: 'default',
    loading: true,
    includeContribution: true,
    analysisCollection: null,
    viewingLockedStrategy: false,
    extra: "",
    max: "",
    simulating: false
  };

  initiateApproval = () => {
    const msdDate = this.props.account.msd.details.request_date;
    if (msdDate && moment().diff(moment(msdDate, 'X'), 'weeks') > 12) {
      const message = "The MSD for this user is more than 3 months old. You're advised to reach out to the user to upload a more recent MSD. Do you still want to continue with the analysis?";
      return this.props.confirmAction(message, this.approve, 'Old MSD');
    }
    return this.approve();
  };

  reviewForms = () => {
    this.props.confirmAction(
      'You have successfully approved the strategy. Do you want to assign new forms based on this strategy.',
      () => {
        this.setState({ busy: true }, async () => {
          const user = await AccountsApi.autoAssignForms(this.props.id);
          this.props.onAccountUpdated(user);
          this.props.onForms();
        })
      },
      'Analysis Approved',
      'Assign Forms',
      "Don't Assign Forms",
    );
  }

  approve = (byPass = false) => {
    if (!byPass && AnalysisTool.strategyRecommendsSameIDR(this.props.account)) {
      this.props.confirmAction(
        'Please confirm that you are aware of the fact that this strategy is recommending the same Income Driven Repayment Plan for some of the loans, which may imply early re-certification and an increase in the monthly payment.',
        () => this.approve(true),
        null,
        null,
        null,
        null,
        true
      );
    } else if ((this.props.account.msd.details || {}).isArtificial) {
      this.props.showError(
        'User has an artificial MSD file, please reach out to user to upload real MSD file'
      );
    } else {
      this.props.confirmAction(
        'You are going to confirm the analysis and strategy for this user. Do you want to proceed?',
        () =>
          this.setState({ busy: true }, () =>
            AccountsApi.approve(this.props.id)
              .then(account => {
               this.reviewForms();
                this.props.onAccountUpdated(account);
                this.setState({ busy: false });
              })
              .catch(() => {
                this.props.showError();
                this.setState({ busy: false });
              })
          )
      );
    }
  };
  canAnalysisBeApproved = () => {
    return !this.props.account.analysis.locked && !this.props.account.analysis.approved
  }
  toggleAnalysis = async (includeContribution, getLockedAnalysis) => {
    try {
      this.setState({ includeContribution, loading: true });
      const preview = await AnalysisApi.getAnalysisV2(
        this.props.account._id,
        includeContribution,
        getLockedAnalysis
      );
      this.setState({
        loading: false,
        analysisCollection: preview,
        simulating: false,
        extra: "",
        max: "",
      });
    } catch (error) {
      this.props.showError(error);
    }
  };
  toggleLockedStrategyView = () => {
    const { viewingLockedStrategy } = this.state;
    this.setState({ viewingLockedStrategy: !viewingLockedStrategy });
    this.toggleAnalysis(true, !viewingLockedStrategy);
  }
  lockOrUnlockAnalysis = async (locked) => {
    try {
      const updatedAnalysis = await AnalysisApi.lockAnalysis(this.props.account._id, locked)
      this.props.showMessage(`Analysis ${locked ? 'locked' : 'unlocked'} successfully`)
      this.props.onAnalysisUpdated(updatedAnalysis)
    } catch (error) {
      this.props.showError(error)
    }
  }
  handleAnalysisLockingUnlocking = () => {
    const isAnalysisCurrentlyLocked = this.props.account.analysis.locked;
    if (isAnalysisCurrentlyLocked) {
      // deleting the locked strategy
      return this.props.confirmAction("Are you sure you want to delete the locked strategy, this is an irreversible action", () => {
        this.toggleLockedStrategyView()
        this.lockOrUnlockAnalysis()
      })
    }
    this.lockOrUnlockAnalysis(true);
    this.props.onAccountUpdated(this.props.account);
  }
  handleGetExtraPaymentPreview = async () => {
    this.setState({
      loading: true,
    });
    const preview = await AnalysisApi.getExtraPaymentPreview(this.props.account._id,
      {
        monthly: Number(this.state.extra) || "",
        maximum: Number(this.state.max) || "",
      })
    this.setState({
      loading: false,
      analysisCollection: preview,
      simulating: true
    });
  }
  componentDidMount() {
    this.toggleAnalysis(true)
  }
  renderActions = () => {
    if (Auth.account.role === "sales") {
      return ""
    }
    return (
      <div className="row" style={{justifyContent: "center"}}>
        {
          !this.props.account.analysis.locked && <button
            className="btn btn-secondary btn-standard mr-2"
            onClick={() => this.setState({ mode: 'edit' })}
          >
            Edit Strategy
          </button>
        }
        {
          this.canAnalysisBeApproved() && <button
            className="btn btn-primary btn-standard loading mr-2"
            disabled={this.state.busy}
            onClick={() => this.initiateApproval()}
          >
            {this.state.busy ? 'Approving...' : 'Approve Strategy'}
          </button>
        }
        {
          this.props.account.analysis.approved && <button
            className="btn btn-primary btn-standard loading mr-2"
            disabled={this.state.busy}
            onClick={this.handleAnalysisLockingUnlocking}
          >
            {this.props.account.analysis.locked ? "Delete locked strategy" : "Lock Strategy"}
          </button>
        }
        {
          this.props.account.analysis.locked && <button
            className="btn btn-secondary btn-standard loading mr-2"
            disabled={this.state.busy}
            onClick={this.toggleLockedStrategyView}
          >
            {this.state.viewingLockedStrategy ? "View live strategy" : "View locked Strategy"}
          </button>
        }
        </div>
    )
  }
  renderOutcome = () => {
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "flex-end", display: 'none' }}>
          <TextField type='number'
            id='extra-payment'
            label="Enter extra payment"
            style={{
                marginRight: "60px"
            }}
            value={this.state.extra}
            onChange={(e) => this.setState({extra: e.target.value})}
          />
          <TextField type='number' id='max'
            label="Maximum contribution"
            className='mr-10'
            style={{
                marginRight: "60px"
            }}
            value={this.state.max}
             onChange={(e) => this.setState({max: e.target.value})}

          />
          <button
            className="btn btn-primary mr-2"
            disabled={!this.state.extra}
            onClick={this.handleGetExtraPaymentPreview}>
            Simulate Analysis
          </button>
        </div>
        <AnalysisOutcome
          account={this.props.account}
          analysisCollection={this.state.analysisCollection}
        />
        <div className="line-break"></div>
        {this.state.simulating ? <div className="row" style={{ justifyContent: "center" }}><button
          className="btn btn-primary btn-standard loading mr-2"
          onClick={() => this.toggleAnalysis(true)}
        >
          Close
        </button></div> : this.renderActions()}
        <div className="row">
          <div className="col-12 text-left">
            <span
              style={{
                fontSize: '10px',
                color: this.props.account.custom_analysis ? 'green' : 'blue'
              }}
            >
              *{' '}
              {this.props.account.custom_analysis
                ? "Coach's custom analysis"
                : 'System analysis'}
            </span>
          </div>
        </div>
      </div>
    );
  };
  showErrorMessage = (type) => {
    if (type === "privateLoan") {
      return <Error>This view is not available to this user because he/she has private loan</Error>;
    }
    if (type === "missingInformation") {
      return <Error>You must enter the user financial and employment information as well as MSD before you can perform an analysis.</Error>;
    }
    if (type === "noanalysis") {
      return <Error>The user does not have an analysis yet, update the General information
      to run the analysis and be able to come back to this screen.</Error>;
    }
  }
  onEditedAnalysisSaved = (updates) => {
    this.toggleAnalysis(true);
    this.props.onAnalysisUpdated(updates);
  }

  renderOutdatedMSD() {
    const { account, msds } = this.props;
    if (account.analysis.locked) {
      const analysisMSD = (msds || []).find(each => each._id === account.analysis.msdId);
      return (
        <>
          <div className="alert">
            <center>
              This user's analysis was locked on {moment(account.analysis.updated, "X").format("MM/DD/YYYY")}
              {analysisMSD && ` using the MSD uploaded on ${moment(analysisMSD.date, "X").format("MM/DD/YYYY")}`}
            </center>
          </div>
          {
            account.msd._id !== account.analysis.msdId && <div className="alert alert-warning">
              <center>
                A more recent MSD has been uploaded on {moment(account.msd.date, "X").format("MM/DD/YYYY")} since the analysis was locked
              </center>
            </div>
          }
        </>
      )
    }
  }
  render() {
    if (this.props.account.loanType === "private") {
      return this.showErrorMessage("privateLoan")
    }
    if (!this.props.account.finances || !this.props.account.employment || !this.props.myStudentData) {
      return this.showErrorMessage("missingInformation")
    }
    if (!this.props.account.analysis) {
      return this.showErrorMessage("noanalysis")
    }
    if (this.state.loading) {
      return (
        <div className='row'>
          <div className='col-6 offset-3 text-center'>
            <Loading message="Loading outcome..." />
          </div>
        </div>
      )
    }
    if (this.state.mode === "edit") {
      return <EditAnalysis
        onEditedAnalysisSaved={this.onEditedAnalysisSaved}
        myStudentData={this.props.myStudentData}
        analysis={this.props.analysis}
        account={this.props.account}
        id={this.props.id}
        onClose={() => this.setState({ mode: "default" })}
      />
    }
    return (
      <>
      {this.renderOutdatedMSD()}
      {this.renderOutcome()}
      </>
    )
  }
}
export default connect(null, { confirmAction, showError, showMessage })(
  StrategyView
);
